<script lang="ts" setup>
  import Status from '@/common/shared/Status.vue';
  import { computed } from 'vue';
  import TooltipWrapper from '@/common/shared/TooltipWrapper.vue';
  import useS3FilesStore, { S3FileState } from '@/common/store/pinia/s3Files';
  import { bytesToUnit, formatPercent } from '@/common/utils/formatter.number';
  import { FileUploadStatuses } from '@/common/constants/fileUpload.constants';

  const s3FilesStore = useS3FilesStore();

  const data = computed(() => s3FilesStore.uploadingFiles);

  const onAbortUpload = (row: S3FileState) => s3FilesStore.abortUpload(row);
</script>

<template>
  <el-table
    class="v-files-loading-table"
    :data="data"
    rowKey="id"
  >
    <el-table-column
      sortable
      :label="$t('Name')"
      prop="data.name"
    >
      <template #default="{ row }">
        <tooltip-wrapper
          :tooltip-text="row.name"
        >
          <el-icon
            class="mr-16"
            size="24"
            :name="row.isFolder ? 'i-folder-o--24' : 'i-file-o--24'"
          /><span>{{ row.name }}</span>
        </tooltip-wrapper>
      </template>
    </el-table-column>
    <el-table-column
      sortable
      :label="$t('Status')"
      prop="statusText"
    >
      <template #default="{ row }">
        <status :status="row.statusIcon">
          <span v-if="row.status === FileUploadStatuses.PROGRESS">
            {{ formatPercent(row.progress) }}
          </span>
          <span v-else>{{ row.statusText }}</span>
        </status>
      </template>
    </el-table-column>
    <el-table-column
      sortable
      :label="$t('Bucket name')"
      prop="bucketName"
    >
      <template #default="{ row }">
        <tooltip-wrapper
          :tooltip-text="row.bucketName"
        >
          {{ row.bucketName }}
        </tooltip-wrapper>
      </template>
    </el-table-column>
    <el-table-column
      sortable
      :label="$t('Size')"
      prop="data.size"
    >
      <template #default="{ row }">
        <span v-if="!row.isFolder">{{ bytesToUnit(row.file.size) }}</span>
        <span v-else>{{ $t('figure dash') }}</span>
      </template>
    </el-table-column>
    <el-table-column
      fixed="right"
      width="90"
    >
      <template #default="{ row }">
        <el-tooltip
          v-if="row.status === FileUploadStatuses.PROGRESS || row.status === FileUploadStatuses.PENDING"
          :content="$t('Cancel upload')"
          placement="right"
        >
          <el-button
            icon="i-times--16"
            type="secondary"
            @click="() => onAbortUpload(row)"
          />
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>
